import React from "react"
import { Helmet } from "react-helmet"
import { Layout } from "../../components/layout"
import { VieSportiveNav } from "../../components/menus/VieSportiveNav"

const Arbitrage: React.FC = () => (
  <Layout>
    <Helmet title="Arbitrage" />
    <div className="container">
      <div className="row mt-3">
        <div className="secondary-col">
          <VieSportiveNav />
        </div>
        <div className="col-md-8 col-lg-9">
          <h1>Arbitrage</h1>
          <br />
          <h2>Règlements officiels</h2>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Document</th>
                <th scope="col">Rév.</th>
                <th scope="col">Lien</th>
              </tr>
            </thead>
            <tbody>
              {/* <tr>
                <td>App - Règlements FFTA</td>
                <td>en cours</td>
                <td>
                  <a href="https://livre-reglements.tiralarc-grand-est.fr/" target="_blank" rel="noopener noreferrer">
                    <span className="icon-link" /> &copy;CRTA GE
                  </a>
                </td>
              </tr> */}
              <tr>
                <td>Livre des règlements FFTA</td>
                <td>Mai 2026</td>
                <td>
                  <a href="https://www.fftiralarc.org/DOCUMENTS/ARBITRES/R%C3%A8glements_sportifs_et_arbitrage_saison_2026_version_20260502.pdf" target="_blank" rel="noopener noreferrer">
                    <span className="icon-download" /> pdf (fichier volumineux)
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <h2>Divers</h2>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Document</th>
                <th scope="col">Rév.</th>
                <th scope="col">Lien</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Liste des arbitres</td>
                <td>Septembre 2025</td>
                <td>
                  <a href="/vie-sportive/documents/arbitres-2026.pdf" target="_blank" rel="noopener noreferrer">
                    <span className="icon-download" /> pdf
                  </a>
                </td>
              </tr>
              <tr>
                <td>Calendrier d'arbitrage extérieur 2025-2026</td>
                <td>11 avril 2026</td>
                <td>
                  <a href="/vie-sportive/documents/calendrier-arbitrage-ext-2026-26-04-11.pdf" target="_blank" rel="noopener noreferrer">
                    <span className="icon-download" /> pdf
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
        </div>
      </div>
    </div>
  </Layout>
)

export default Arbitrage
